import React, { useState, useEffect } from 'react';
import { about } from '../../../json/sections/about/about';
import './aboutUs.css';
// import { FaRegArrowAltCircleRight } from 'react-icons/fa';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import CardSlider from './CardSlider/CardSlider';
import HeroSection from './HeroSection/HeroSection';
import ReasonSection from './ReasonSection/ReasonSection';
import Alliances from '../Home/Alliances/Alliances';
import { Link } from 'react-router-dom';
import Banner from '../../Layout/Banner/Banner';

const AboutUs = () => {
  // Detectar dispositivo móvil
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 768);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const {
    title,
    paragraphs,
    imageUrl,
    topSection,
    bottomSection,
    workSection
  } = about;

  // Altura dinámica para la imagen
  const imgHeight = isMobile ? '100%' : '140%';

  return (
    <>
      <Banner />
      <div className="container-fluid container-mh container-about">
        <div className="row">
          <div className="col-md-6 col-background">
            <div className="box-about">
              <h1 dangerouslySetInnerHTML={{ __html: title }} />
              {paragraphs.map((text, idx) => (
                <p key={idx}>
                  {text}
                  {idx < paragraphs.length - 1 && <><br /><br /></>}
                </p>
              ))}
            </div>
          </div>
          <div className="col-md-6 col-background">
            <div
              className="img-about"
              style={{
                backgroundImage: `url('${imageUrl}')`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                height: imgHeight
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 my-fixed-col position-relative">
            <div className="top-text">
              <h1>
                {topSection.main} <span>{topSection.highlight}</span>
              </h1>
            </div>
            <div className="bottom-text line-height-clss">
              <span>{bottomSection.highlight}</span>
              <h1 className='line-height-clss'>
                {bottomSection.rest}
              </h1>
            </div>
          </div>
          <div className="col-md-8">
            <div
              className="background-high-rise"
              style={{
                backgroundImage: `url('${workSection.bgImage}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                height: '800px'
              }}
            >
              <div
                className="background-high-rise-color"
                style={{ backgroundColor: workSection.bgColor }}
              >
                <div className="background-high-rise-color-content">
                  <h1 className='line-height-clss text-center'>
                    {workSection.heading}<br />
                    <span>{workSection.highlight}</span>
                  </h1>
                  <Link to={workSection.ctaLink}>
                    <IoArrowForwardCircleOutline className="arrow-work" />
                  </Link>
                </div>
                <div className="background-high-rise-color-parraf">
                  <p>{workSection.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CardSlider />
      <HeroSection />
      <ReasonSection />
      <Alliances />
    </>
  );
};

export default AboutUs;
